import type { User } from '@closetly/core';
import { useMemo, useSyncExternalStore } from 'react';
import { pb } from './pb';

function subscribe(cb: () => void) {
  return pb.authStore.onChange(cb);
}

/** The signed-in user from the persisted auth store, or null. */
export function useAuthUser(): User | null {
  // LocalAuthStore re-parses localStorage on every `record` read, so the
  // token string is the stable snapshot and the record is derived from it.
  const token = useSyncExternalStore(subscribe, () => pb.authStore.token);
  return useMemo(() => {
    const record = pb.authStore.record;
    return token && pb.authStore.isValid && record ? (record as unknown as User) : null;
  }, [token]);
}

export async function login(email: string, password: string) {
  await pb.collection('users').authWithPassword(email, password);
}
